/**
 * Derniers produits consultés.
 *
 * L'historique vit dans le navigateur du visiteur, jamais sur le serveur :
 * rien n'est envoyé nulle part, et la section reste masquée tant qu'il n'y a
 * rien à montrer.
 */

const KEY = 'lrs:recent';
const CAP = 12;

function read() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
  } catch {
    // Navigation privée, stockage bloqué, quota plein : on fait sans.
    return [];
  }
}

function remember(handle) {
  if (!handle) return;
  try {
    const list = read().filter((h) => h !== handle);
    list.unshift(handle);
    window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP)));
  } catch {
    /* sans stockage, la section restera simplement vide */
  }
}

function render(root) {
  const list = root.querySelector('[data-lrs-recent-list]');
  const pool = root.querySelector('[data-lrs-recent-pool]');
  if (!list || !pool) return;

  const current = root.dataset.current || '';
  const max = parseInt(root.dataset.max || '5', 10) || 5;

  // Le produit affiché n'a pas sa place dans « vous avez regardé ».
  const wanted = read().filter((h) => h !== current);
  if (!wanted.length) return;

  const byHandle = new Map();
  pool.content.querySelectorAll('[data-handle]').forEach((n) => byHandle.set(n.dataset.handle, n));

  let shown = 0;
  for (const handle of wanted) {
    if (shown >= max) break;
    const node = byHandle.get(handle);
    if (!node) continue;
    list.appendChild(node.cloneNode(true));
    shown += 1;
  }

  if (shown > 0) root.hidden = false;
}

function scan(scope) {
  (scope || document).querySelectorAll('[data-lrs-recent]').forEach((root) => {
    if (root.dataset.lrsArmed === 'on') return;
    root.dataset.lrsArmed = 'on';
    // On enregistre avant de rendre, mais le produit courant est exclu du
    // rendu : il apparaîtra à la visite suivante, pas sur sa propre page.
    render(root);
    remember(root.dataset.current);
  });
}

scan(document);
document.addEventListener('shopify:section:load', (event) => scan(event.target));
